module.exports = __webpack_public_path__ + "img/1.b992ced6.png";